// Search vocabulary only: routes, labels and permissions remain owned by the router.
export const PAGE_SEARCH_ALIASES = {
  '/access/admins': ['مدیریت ادمین‌ها', 'گواهی بازبین', 'صلاحیت بازبین', 'مدیران'],
  '/access/security': ['امنیت', 'نشست', 'دستگاه', 'خروج اجباری'],
  '/access/ip-allowlist': ['فهرست IP مجاز', 'آی پی', 'CIDR'],
  '/access/compliance': ['انطباق', 'خروجی داده', 'حذف حساب', 'حریم خصوصی'],
  '/access/moderation': ['محتوای گزارش‌شده', 'تخلف', 'گزارش محتوا'],
  '/': ['داشبورد', 'داشبورد مدیریتی', 'صفحه اصلی'],
  '/command-center': ['مرکز فرماندهی', 'کارهای روزانه'],
  '/question-bank/questions': ['سؤالات', 'سوالات', 'سوال ها', 'بانک سوالات', 'بانک تست'],
  '/question-bank/review-queue': ['صف بازبینی', 'صف بررسی', 'داوری سوالات', 'تایید سوالات'],
  '/question-bank/revision-queue': ['اصلاح سوالات', 'بازنویسی سوالات'],
  '/question-bank/content-repair': ['میز ترمیم محتوا', 'ترمیم محتوا'],
  '/question-bank/blueprints': ['بلوپرینت', 'بلوبرینت', 'الگوی سوال', 'قالب سوال'],
  '/question-bank/batches': ['برنامه ریزی محتوا', 'برنامه‌ریزی تولید', 'دسته های تولید', 'بچ'],
  '/question-bank/generate': ['ساخت سوال', 'طراحی سوال', 'تولید سوال'],
  '/curriculum/structure': ['ساختار آموزشی', 'کتاب درسی', 'کتاب ها', 'فصل ها', 'چاپ کتاب', 'پی دی اف', 'pdf'],
  '/curriculum/concepts': ['مفاهیم', 'مفهوم', 'موضوعات درسی', 'صفحات مباحث'],
  '/curriculum/exam-windows': ['پنجره آزمون', 'تقویم آزمون', 'بودجه بندی آزمون', 'کانون'],
  '/support': ['تیکت', 'تیکت ها', 'پشتیبانی کاربران'],
  '/revenue/coupons': ['کوپن', 'کوپن ها', 'کد تخفیف'],
  '/ops/slow-queries': ['کوئری های کند', 'کوئری کند', 'slow queries', 'گزارش‌های کند پایگاه داده'],
  '/ops/endpoint-latency': ['کندی پاسخ سرویس‌ها', 'تاخیر', 'latency', 'p95'],
  '/ops/live-sessions': ['تمرین‌های اخیر', 'جلسه‌های تمرین فعال', 'جلسه‌های آنلاین', 'سشن زنده', 'جلسه فعال'],
  '/analytics/exam-countdown': ['تمرین برای آزمون پیش رو', 'برنامه کانون', 'شمارش معکوس کنکور', 'زمان باقی‌مانده تا کنکور', 'تقویم کنکور'],
  '/analytics/learning-gains': ['گزارش کلی یادگیری'],
  '/growth/population': ['تحلیل یادگیری کل دانش‌آموزان'],
  '/analytics/goal-progress': ['پیشرفت هدف‌گذاری'],
  '/analytics/milestones': ['نشان‌های پیشرفت یادگیری'],
  '/analytics/at-risk-learners': ['هشدار اولیه', 'در خطر ریزش'],
  '/analytics/churn-timeline': ['روند ریزش', 'جریان ریزش', 'خط زمانی ریزش'],
  '/analytics/subscription-funnel': ['قیف اشتراک', 'خرید اشتراک', 'پرداخت', 'درگاه', 'مارکت'],
  '/analytics/campaign-effectiveness': ['اثربخشی کمپین'],
  '/growth/marketing': ['منشأ جذب کاربران', 'اتریبیوشن بازاریابی', 'کمپین جذب', 'هزینه تبلیغات', 'CAC', 'ROAS', 'ردیابی نصب'],
  '/growth/referrals': ['دعوت دوستان'],
  '/growth/experiments': ['مدیریت آزمایش‌ها'],
  '/growth/analytics': ['تحلیل رشد و محصول'],
}
